import { DaoType, DtoType } from '../mapper';
import { Pageable } from '../pageable';
import { PagedData } from '../paged-data';
import { UUID } from '../uuid';
import { SearchResultDao } from './search-result.dao';
import { SearchResultDto } from './search-result.dto';
import { SearchResultMapper } from './search-result.mapper';

export interface SearchQuery {
  userId: UUID;
  term: string;
  pageable: Pageable;
}

/**
 * What a {@link SearchService} needs from its repository. Repositories never declare it: manual and
 * generated ones alike match it by shape, so the backend need not say which services can search.
 */
export interface SearchSource<Dao extends DaoType> {
  search(query: SearchQuery): Promise<PagedData<SearchResultDao<Partial<Dao>>>>;
}

export abstract class SearchService<Dao extends DaoType, Dto extends DtoType> {
  protected constructor(
    protected readonly searchSource: SearchSource<Dao>,
    protected readonly searchResultMapper: SearchResultMapper<Dao, Dto>,
  ) {}

  search(query: SearchQuery): Promise<PagedData<SearchResultDto<Dto>>> {
    return this.searchResultMapper.fromSearchResultDao(this.searchSource.search(query));
  }
}
